import axios from "axios";

import { config } from "../../../config/env";
import traceId from "../../../redux/traceId";
import { FEATURE_FLAGS } from "../../constants/FeatureFlag";

export const CHECKOUT_PROVIDER_FLAG_TIMEOUT_MS = 5000;

export const fetchJussubCheckoutFlag = async ({
  timeoutMs = CHECKOUT_PROVIDER_FLAG_TIMEOUT_MS,
} = {}) => {
  const { data } = await axios.get(
    `${config.featureFlag.featureFlagApiUrl}/unleash/is-enabled/${
      FEATURE_FLAGS.KILL_SWITCH.ENABLE_JUSSUB_CHECKOUT
    }`,
    {
      headers: {
        "x-api-key": config.featureFlag.featureFlagApiKey,
        "x-trace-id": traceId,
      },
      timeout: timeoutMs,
    }
  );

  return Boolean(data);
};
